/**
 * LoadingSpinner Component
 * Animated loading indicator
 */

import React from 'react';

function LoadingSpinner() {
    return (
        <div className="loading-spinner">
            <div className="spinner"></div>
            <p className="loading-text">Finding the perfect recommendations...</p>
        </div>
    );
}

export default LoadingSpinner;
